// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__NS36L","title":"AfterFrontImage_title__jsleJ"};